<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="400">
      <v-card color="tertiary darken-1" dark>
        <v-card-text class="text-xs-right">
          <img id="logo" src="/logo.svg" />
          <v-progress-linear indeterminate color="white" class="mb-0" />
          <br>
          <span>Please wait...</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    dialog: state => state.loader.on
  }),
  watch: {
    dialog (val) {
      return (!val)
    }
  }
}
</script>
